
function saveTokenAsCookie(token) {
    // const expires = new Date();
    // expires.setTime(expires.getTime() + 3 * 60 * 60 * 1000);
    // console.log(expires.toUTCString());
    // document.cookie = `authToken=${token};expires=${expires.toUTCString()}; path=${process.env.REACT_APP_BROWSER_ROUTER_BASE_NAME}`;
    const tresHoras = 3 * 60 * 60; // 10800 segundos
    document.cookie = `authToken=${token}; max-age=${tresHoras}; path=${process.env.REACT_APP_BROWSER_ROUTER_BASE_NAME}`;
};

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
};

function deleteCookies() {
    console.log('Iniciando deleteCookies');
    console.log(process.env.REACT_APP_BROWSER_ROUTER_BASE_NAME);
    document.cookie = `authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${process.env.REACT_APP_BROWSER_ROUTER_BASE_NAME};`;
}

function saveUserInfo(data) {

    clearUserInfo();

    localStorage.setItem('nome', data.nome);
    localStorage.setItem('cpf', data.cpf);
    localStorage.setItem('unidade', data.unidade);
    localStorage.setItem('roles', JSON.stringify(data.roles));
}

function getUserInfo() {
    return {
        'nome': localStorage.getItem('nome'),
        'cpf': localStorage.getItem('cpf'),
        'unidade': localStorage.getItem('unidade'),
    }
}

function getUserRolesList() {
    const rolesString = localStorage.getItem('roles')
    if ( rolesString && rolesString !== 'undefined' ) return JSON.parse(rolesString)
}

function clearUserInfo() {
    console.log('Iniciando clearUserInfo');
    localStorage.clear();
}

export {
    saveUserInfo,
    clearUserInfo,
    saveTokenAsCookie,
    getCookie,
    deleteCookies,
    getUserInfo,
    getUserRolesList
}